module.exports = __webpack_public_path__ + "img/gis.c6fe017c.png";